import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Plus as PlusIcon } from '@phosphor-icons/react/dist/ssr/Plus';
import type Project from 'benchmarking-domain/project';
import { ProjectsTable } from 'components/client/projects/projects-table';
import useApi from 'hooks/use-api';
import { useNavigate } from 'react-router-dom';

import { useOrganisation } from '../../../hooks/use-organisation';
import { paths } from '../../../paths';

export default function Projects(): React.JSX.Element {
  const navigate = useNavigate();
  const { organisationId } = useOrganisation();
  const { subscribeProjects } = useApi();
  const [projects, setProjects] = useState<Project[]>([]);

  useEffect(() => {
    if (!organisationId) {
      return;
    }

    const unsubscribe = subscribeProjects(organisationId, (fetchedProjects) => {
      setProjects(fetchedProjects);
    });

    return () => {
      unsubscribe();
    };
  }, [subscribeProjects, organisationId]);

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={3}>
        <Stack spacing={1} sx={{ flex: '1 1 auto' }}>
          <Typography variant="h4">Projects</Typography>
        </Stack>
        <div>
          <Button
            startIcon={<PlusIcon fontSize="var(--icon-fontSize-md)" />}
            onClick={() => {
              navigate(paths.app.client.projects.add);
            }}
            variant="contained"
          >
            Add
          </Button>
        </div>
      </Stack>

      <ProjectsTable rows={projects} />
    </Stack>
  );
}
